<div
  class="w-100"
  [ngClass]="{
    'wizard-small-input-wrapper': selectSettings.questionOptions.length < 5,
    'wizard-input-wrapper': selectSettings.questionOptions.length >= 5
  }"
  [@opacityAnimation]   
>


  <select
    [id]="selectSettings.inputName"
    class="wizard-select"
    [(ngModel)]="selectSettings.selectedOption"  
    (change)="selectOption($event)"
    >
        
    <option *ngFor="let option of selectSettings.questionOptions ; let i = index" [value]="option.value" [disabled]="i === 0" >
      {{ option.title }}
    </option>
  </select> 
   
</div>